import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title:'哈尔滨了然科技开发有限公司',
    pageCount:8,
    selected:0,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
